var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDidnerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_12232)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 17C33 25.8366 25.8366 33 17 33C8.16344 33 1 25.8366 1 17C1 8.16344 8.16344 1 17 1C25.8366 1 33 8.16344 33 17ZM6.75509 17C6.75509 22.6581 11.3419 27.2449 17 27.2449C22.6581 27.2449 27.2449 22.6581 27.2449 17C27.2449 11.3419 22.6581 6.75509 17 6.75509C11.3419 6.75509 6.75509 11.3419 6.75509 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2204 18.7873C18.1939 18.8623 18.1978 18.9448 18.2314 19.0169C18.2649 19.0891 18.3254 19.1453 18.3998 19.1734C18.4743 19.2015 18.5568 19.1993 18.6297 19.1673C18.7025 19.1353 18.7599 19.076 18.7896 19.0021C21.0965 14.5068 23.1114 15.1684 23.4913 15.3056C24.7481 15.7632 22.6171 22.0589 13.1439 23.8293C12.6905 23.9131 12.5402 24.5039 12.6245 24.9569C12.6757 25.1667 12.8041 25.3495 12.984 25.469C13.164 25.5884 13.3823 25.6357 13.5955 25.6015C19.6961 25.0078 24.3834 21.0304 25.4962 16.5235C25.7559 15.4752 25.7626 13.7071 23.8917 13.5921C21.1228 13.4203 18.4764 15.8585 18.2078 18.7869M14.0593 13.3661C11.1205 13.2114 8.33017 15.4841 8.09826 18.2467C7.94353 20.1157 9.69382 20.3617 10.7662 20.2552C15.3892 19.7892 20.0034 15.7116 21.4683 9.77054C21.5325 9.56296 21.5156 9.33879 21.4212 9.14313C21.3267 8.94747 21.1617 8.79485 20.9592 8.71598C20.5295 8.56571 19.9173 8.6299 19.7692 9.06812C16.6586 18.1862 10.1239 19.3914 9.85115 18.0897C9.76951 17.6923 9.40588 15.6036 14.184 13.9654C14.2598 13.9453 14.3259 13.8987 14.3704 13.8342C14.4149 13.7696 14.4349 13.6912 14.4267 13.6132C14.4048 13.5348 14.355 13.4671 14.2867 13.4228C14.2183 13.3785 14.1362 13.3607 14.0556 13.3728M5.25 17.2496C5.25007 14.9257 5.93926 12.654 7.23041 10.7218C8.52156 8.78956 10.3567 7.28359 12.5037 6.39431C14.6508 5.50504 17.0133 5.27241 19.2925 5.72582C21.5718 6.17924 23.6654 7.29835 25.3086 8.94163C26.9519 10.5849 28.0709 12.6786 28.5242 14.9578C28.9776 17.2371 28.7449 19.5996 27.8555 21.7466C26.9662 23.8936 25.4602 25.7287 23.5279 27.0198C21.5956 28.3109 19.3239 29 17 29C15.4569 29 13.929 28.6961 12.5034 28.1056C11.0778 27.515 9.78246 26.6495 8.69136 25.5584C7.60027 24.4672 6.73478 23.1719 6.14431 21.7463C5.55384 20.3207 5.24995 18.7927 5.25 17.2496Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_12232"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDidnerIcon);
export default __webpack_public_path__ + "static/media/DidnerIcon.92c754d9fbc09563a1460de17383c456.svg";
export { ForwardRef as ReactComponent };